import { Box, Dialog, Grid, useMediaQuery, useTheme } from "@mui/material";
import Header from "components/Header";
import DashboardTabs from "components/dashboard/dashboard-tabs";
import BookingDetails from "components/rental-history/booking-details";
import RentalBookings from "components/rental-history/renal-bookings";
import { RENTAL_API_TYPE } from "constants/general";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getOwnerRentalList,
  setBookingType,
  setSelectedBookingId,
} from "slices/rentalsReducer";
import { useAppDispatch } from "store/appHooks";
import useQuery from "utils/router.util";

const requestStatusMap: any = {
  pending: 1,
  confirmed: 3,
  return: 7,
  cancelled: 4,
};

const RentalHistoryPage = () => {
  const dispatch = useAppDispatch();
  const query = useQuery();
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  const qType = query.get("type");
  const qBooking = query.get("booking");
  const navigate = useNavigate();

  const [stateQType, setStateQType] = useState<any>(qType);

  const init = useCallback(() => {
    dispatch(
      getOwnerRentalList({
        requestType: RENTAL_API_TYPE.OWNER,
        type: requestStatusMap[stateQType || "pending"],
        qBooking: qBooking ? Number(qBooking) : 0,
        callBack: (firstId: any) => {
          console.log(firstId);
          if (!qBooking && firstId && !matchesSm && !matchesXs)
            navigate(
              `/rental/?type=${stateQType || "pending"}&booking=${Number(
                firstId?.id
              )}`
            );
        },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateQType]);

  const getBDetails = useCallback(() => {
    if (qBooking) {
      dispatch(setSelectedBookingId(Number(qBooking)));
    } else {
      dispatch(setSelectedBookingId(0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qBooking]);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateQType]);

  useEffect(() => {
    setStateQType(qType);
  }, [qType]);

  useEffect(() => {
    if (qBooking) {
      getBDetails();
    } else {
      dispatch(setSelectedBookingId(0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qBooking]);

  return (
    <Box>
      <DashboardTabs tab="rental" />
      <Box>
        <Grid container>
          <Grid item md={3.5} lg={3.5} xl={3.5} sm={12} xs={12}>
            <RentalBookings />
          </Grid>
          <Grid item md={8.5} lg={8.5} xl={8.5} sm={false} xs={false}>
            <Box
              sx={{
                display: {
                  sm: "none",
                  xs: "none",
                  md: "block",
                  lg: "block",
                  xl: "block",
                },
              }}
            >
              <BookingDetails />
            </Box>
          </Grid>
        </Grid>
        {(matchesSm || matchesXs) && (
          <Dialog
            open={Boolean(query.get("booking"))}
            sx={
              {
                //   ".MuiPopover-root": {
                //     mt: "65px",
                //   },
                //   ".MuiBackdrop-root": {
                //     opacity: "0 !important",
                //   },
                // ".MuiDialog-container": {
                //   mt: "65px",
                // },
              }
            }
            fullScreen
            PaperProps={{
              elevation: 0,
            }}
          >
            <Header />
            <BookingDetails />
          </Dialog>
        )}
      </Box>
    </Box>
  );
};

export default RentalHistoryPage;
